<template>
  <div v-if="roll" class="troll" @click="onTap">
    <div class="troll__box" @click.stop="onTap">
      <div class="troll__title">{{ $tut('tut.rollTitle') }}</div>
      <div class="troll__sub">{{ $tut('tut.rollSub') }}</div>

      <!-- ЛЕНТА РУЛЕТКИ: едет под неподвижной рамкой и тормозит на выпавшей награде (решение
           оунера 2026-08-17). Ролл считает СЕРВЕР — анимация только показывает его результат. -->
      <div ref="track" class="troll__track">
        <div class="troll__lane" :style="laneStyle">
          <div
            v-for="(it, i) in strip" :key="i"
            class="troll__cell" :class="{ 'troll__cell--win': done && i === targetIndex }"
          >
            <span class="troll__ico">{{ ICONS[it.key] || '🎁' }}</span>
            <span class="troll__amount">{{ amountText(it) }}</span>
          </div>
        </div>
        <div class="troll__pointer" :style="pointerStyle"></div>
      </div>

      <div class="troll__got">{{ done ? $tut('tut.rollGot', { reward: amountText(win) }) : $tut('tut.rollSub') }}</div>
      <button class="troll__btn" :disabled="!done" @click.stop="close">{{ $tut('tut.gotIt') }}</button>
    </div>
  </div>
</template>

<script>
/**
 * Окно награды за микро-шаг обучения (решение оунера 2026-07-29): каждый шаг заканчивается
 * роллом рулетки. Ролл делает СЕРВЕР (`POST /tutorial/step` → `roll: {items, index}`), клиент
 * только показывает ленту и выпавшую ячейку — подделать выигрыш нельзя.
 *
 * 🔴 ЛЕНТА ЕДЕТ 2 СЕКУНДЫ (просьба оунера 2026-08-17): без движения окно читалось как «просто
 * сообщение», а не как выигрыш. Тап в любом месте окна ОБРЫВАЕТ прокрутку и сразу показывает
 * результат — ждать анимацию никого не заставляем.
 */
const ICONS = {
  energy: '⚡', gems_small: '💎', materials: '🪵', boost_minutes: '⏳', tickets: '🎟️',
  scroll_apprentice: '📜', scroll_master: '📕', ether: '🧊', hammer: '🔨',
};
const LOOPS = 4;          // сколько раз лента прокручивает весь набор до остановки
const SPIN_MS = 2000;     // длительность прокрутки (просьба оунера)

export default {
  name: 'TutorialRoll',
  data() {
    // 🔴 ШАГ ЛЕНТЫ МЕРЯЕМ ПО DOM, А НЕ КОНСТАНТОЙ: у ячейки свои поля и рамка, и «104px» из стилей
    // не равны её реальной ширине — лента останавливалась мимо выпавшей награды (поймано снимком).
    return { ICONS, offset: 0, spinning: false, done: false, timer: null, trackW: 0, cellW: 104, step: 112 };
  },
  computed: {
    roll() { return this.$store.getters.tutorialRoll; },
    win() { return this.roll ? this.roll.items[this.roll.index] : null; },
    // лента = набор наград, повторённый LOOPS+1 раз: едем по кругам и тормозим на выпавшей ячейке
    strip() {
      const items = (this.roll && this.roll.items) || [];
      if (!items.length) return [];
      const out = [];
      for (let i = 0; i <= LOOPS; i += 1) out.push(...items);
      return out;
    },
    // индекс выпавшей ячейки в ленте (последний круг)
    targetIndex() {
      const items = (this.roll && this.roll.items) || [];
      return items.length ? items.length * LOOPS + this.roll.index : 0;
    },
    pointerStyle() { return { width: `${Math.round(this.cellW) + 4}px` }; },
    laneStyle() {
      return {
        transform: `translateX(${this.offset}px)`,
        transition: this.spinning ? `transform ${SPIN_MS}ms cubic-bezier(0.12, 0.72, 0.16, 1)` : 'none',
      };
    },
  },
  watch: {
    roll: { handler(v) { if (v) this.start(); }, immediate: true },
  },
  beforeUnmount() { if (this.timer) clearTimeout(this.timer); },
  methods: {
    amountText(it) {
      if (!it) return '';
      return `${it.amount} ${this.$t('daily.res.' + it.key)}`;
    },
    // сдвиг ленты, при котором ячейка `i` стоит по центру окошка
    offsetFor(i) {
      return Math.round(this.trackW / 2 - (i * this.step + this.cellW / 2));
    },
    // фактические размеры ячейки и шага ленты (со всеми полями, рамками и зазором)
    measureCells() {
      const lane = this.$refs.track && this.$refs.track.querySelector('.troll__lane');
      const cells = lane ? lane.children : null;
      if (!cells || cells.length < 2) return;
      const a = cells[0].getBoundingClientRect();
      const b = cells[1].getBoundingClientRect();
      if (a.width > 0) this.cellW = a.width;
      if (b.left - a.left > 0) this.step = b.left - a.left;
    },
    async start() {
      if (this.timer) clearTimeout(this.timer);
      this.done = false;
      this.spinning = false;
      await this.$nextTick();
      const el = this.$refs.track;
      this.trackW = (el && el.clientWidth) || 0;
      this.measureCells();
      const items = (this.roll && this.roll.items) || [];
      if (!items.length || !this.trackW) { this.finish(); return; }
      this.offset = this.offsetFor(this.roll.index); // старт — с той же награды первого круга
      await this.$nextTick();
      requestAnimationFrame(() => {
        this.spinning = true;
        this.offset = this.offsetFor(this.targetIndex);
        this.timer = setTimeout(this.finish, SPIN_MS + 60);
      });
    },
    // остановить ленту на выпавшей награде (по концу анимации или по тапу игрока)
    finish() {
      if (this.timer) { clearTimeout(this.timer); this.timer = null; }
      this.spinning = false;
      if (this.trackW) this.offset = this.offsetFor(this.targetIndex);
      this.done = true;
    },
    onTap() { if (!this.done) this.finish(); },
    close() { if (!this.done) { this.finish(); return; } this.$store.dispatch('closeTutorialRoll'); },
  },
};
</script>

<style scoped lang="scss">
.troll {
  position: absolute; inset: 0; z-index: 1200;
  display: flex; align-items: center; justify-content: center;
  background: rgba(6, 3, 14, 0.62);
  text-align: center; line-height: 1.3;

  &__box {
    width: min(620px, 92%); border-radius: 16px; padding: 16px 18px 18px;
    border: 1px solid rgba(255, 200, 90, 0.6);
    background: linear-gradient(140deg, rgba(62, 44, 32, 0.98), rgba(28, 19, 44, 0.99));
    box-shadow: 0 18px 46px rgba(0, 0, 0, 0.5);
  }
  &__title {
    font-size: 1.2em; font-weight: 700;
    background: linear-gradient(90deg, #ffe27a, #ffb347);
    -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;
  }
  &__sub { font-size: 0.78em; color: #b3a5d8; margin-top: 2px; }

  // окошко ленты: сама лента едет внутри, рамка выбора стоит по центру
  &__track {
    position: relative; overflow: hidden; margin: 14px 0 6px;
    padding: 6px 0; border-radius: 12px;
    background: rgba(12, 8, 22, 0.55);
    box-shadow: inset 0 0 22px rgba(0, 0, 0, 0.55);
    // края ленты затемняем — видно, что набор продолжается за окошком
    mask-image: linear-gradient(90deg, transparent, #000 12%, #000 88%, transparent);
    -webkit-mask-image: linear-gradient(90deg, transparent, #000 12%, #000 88%, transparent);
  }
  &__lane { display: flex; gap: 8px; will-change: transform; }
  &__pointer {
    position: absolute; top: 2px; bottom: 2px; left: 50%;
    transform: translateX(-50%); border-radius: 12px; pointer-events: none;
    border: 2px solid rgba(255, 210, 120, 0.95);
    box-shadow: 0 0 0 2px rgba(255, 190, 70, 0.22), 0 0 26px rgba(255, 180, 60, 0.35);
  }
  &__cell {
    box-sizing: border-box; // ширина ячейки = ровно 104px вместе с полями и рамкой
    position: relative; flex: 0 0 104px; width: 104px; border-radius: 12px; padding: 10px 6px 9px;
    border: 1px solid rgba(150, 130, 220, 0.4); background: rgba(24, 16, 40, 0.8);
    &--win {
      border-color: rgba(255, 210, 120, 0.95); background: rgba(96, 62, 30, 0.85);
    }
  }
  &__ico { display: block; font-size: 1.6em; }
  &__amount { display: block; font-size: 0.78em; color: #ded3f5; margin-top: 4px; }
  &__cell--win &__amount { color: #ffe27a; font-weight: 700; }

  &__got { font-size: 0.9em; color: #f6ecd2; margin-top: 10px; min-height: 1.3em; }
  &__btn {
    font-family: inherit; font-size: 0.86em; border-radius: 11px; padding: 8px 22px; margin-top: 12px; cursor: pointer;
    border: 1px solid rgba(255, 200, 90, 0.6); color: #3a2500; font-weight: 700;
    background: linear-gradient(135deg, #ffd257, #f0a13a);
    &:disabled { opacity: 0.45; cursor: default; }
  }
}
</style>
